import { render, staticRenderFns } from "./BaseNamePreviewFileUploadInput.vue?vue&type=template&id=38b6fb0d&scoped=true"
import script from "./BaseNamePreviewFileUploadInput.vue?vue&type=script&lang=js"
export * from "./BaseNamePreviewFileUploadInput.vue?vue&type=script&lang=js"
import style0 from "./BaseNamePreviewFileUploadInput.vue?vue&type=style&index=0&id=38b6fb0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b6fb0d",
  null
  
)

export default component.exports